// frontend/src/pages/BogoPage.jsx   (route: /bogo)
// Lists ONLY the products that are eligible for the live offer.
import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsByFilters } from "../../redux/slices/productsSlice";
import ProductGrid from "../components/Products/ProductGrid";
import { useActiveOffer } from "../offers/useOffer";
import { isEligible } from "../offers/offerEngine";


const BogoPage = () => {
  const dispatch = useDispatch();
  // `loading` is only used if useActiveOffer exposes it; otherwise it is undefined (falsy) and nothing changes.
  const { offer, loading: offerLoading } = useActiveOffer();
  const { products, loading, error } = useSelector((s) => s.products);

  useEffect(() => {
    dispatch(fetchProductsByFilters({ lite: true }));
  }, [dispatch]);

  const eligibleProducts = useMemo(
    () => (offer ? (products || []).filter((p) => isEligible(offer.eligible, p._id)) : []),
    [products, offer]
  );

  // Show the light skeleton only when there is nothing to show yet. If products are already in the
  // store (e.g. visitor came from the shop page) they render instantly while the refresh happens quietly.
  const gridLoading = !!offerLoading || (loading && eligibleProducts.length === 0);

  return (
    <>
      <style>{styles}</style>
      <div className="bp-wrap">
        <div className="bp-head">
          <span className="bp-eyebrow">{offer ? offer.name : "BOGO"}</span>
          <h1 className="bp-title">Buy 1 Get 1 Free</h1>
          {offer ? (
            <p className="bp-sub">
              Add any 2 items below. The higher price is paid, the cheaper one is free.
              {offer.maxFreeItems > 0 ? ` Up to ${offer.maxFreeItems} free per order.` : ""}
            </p>
          ) : !offerLoading ? (
            <p className="bp-sub">There is no BOGO offer live right now.</p>
          ) : null}
        </div>

        {!offer && !offerLoading && (
          <div className="bp-empty">
            <Link to="/collections/all" className="bp-cta">Shop all</Link>
          </div>
        )}

        {offer && !loading && !error && eligibleProducts.length === 0 && (
          <div className="bp-empty"><p className="bp-sub">No eligible products found.</p></div>
        )}

        {(offer || offerLoading) && (
          <ProductGrid products={eligibleProducts} loading={gridLoading} error={error} />
        )}
      </div>
    </>
  );
};

const styles = `
  .bp-wrap { font-family: 'Exo 2', sans-serif; padding: 40px 0 60px; }
  .bp-head { text-align: center; padding: 0 20px 36px; }
  .bp-eyebrow { font-size: 10px; font-weight: 500; letter-spacing: 0.45em; text-transform: uppercase; color: #000; }
  .bp-title { font-size: 28px; font-weight: 300; letter-spacing: 0.3em; text-transform: uppercase; margin: 14px 0 12px; color: #000; }
  .bp-sub { font-size: 10px; font-weight: 300; letter-spacing: 0.2em; text-transform: uppercase; color: #000; line-height: 1.9; max-width: 520px; margin: 0 auto; }
  .bp-empty { text-align: center; padding: 30px 20px; }
  .bp-cta { display: inline-block; margin-top: 12px; background: #000; color: #fff; font-size: 9px; font-weight: 600; letter-spacing: 0.4em; text-transform: uppercase; padding: 12px 28px; text-decoration: none; }
`;

export default BogoPage;
